module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzMzNDk2IDE4Ljc1TDEzLjc5MTggOS41TDAuMzMzNDk2IDAuMjVWMTguNzVaTTE0LjU4MzUgMC4yNVYxOC43NUwyOC4wNDE4IDkuNUwxNC41ODM1IDAuMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/next.svg
// module id = blKI
// module chunks = 7